export const PVGreen = '#B1F3D9';
export const PVGreenDark = '#00BF8F';
export const PVIvory = '#F7F0ED';
export const PVYellow = '#FFEBA3';
export const PVOrange = '#FFBBA6';
export const PVRed = '#FE6257';
export const PVDarkRed = '#F24D3B';
export const PVPurple = '#D9D8FF';
export const PVMediumPurple = '#504E83';
export const PVPink = '#FF8B99';
export const PVLightPink = '#FFC5CC';
export const PVNavy = '#3B396C';
export const PVHoverNavy = '#F4F3FF';
export const PVHoverNavyDark = '#E8E7FF';
export const PVBlack = '#222222';
export const PVGray = '#666666';
export const PVMediumGray = '#B3B3B3';
export const PVLightGray = '#E8E8E8';
export const PVPremiumPurple = '#6D72F4FF';
export const PVWhite = '#FFFFFF';
const textColor = PVBlack;

export const success = {
  backgroundColor: PVGreen,
  backgroundColorLight: 'rgba(177, 243, 217, 0.7)',
  backgroundColorDark: '#00C6A2',
  textColor,
};

export const warn = {
  backgroundColor: PVYellow,
  backgroundColorLight: 'rgba(241, 157, 56, 0.15)',
  textColor,
};

export const danger = {
  backgroundColor: PVRed,
  backgroundColorLight: 'rgba(254, 98, 87, 0.15)',
  textColor,
};

export const orange = {
  backgroundColor: PVOrange,
  backgroundColorLight: 'rgba(255, 202, 185, 0.15)',
  textColor,
};

export const purple = {
  backgroundColor: PVPurple,
  textColor,
};

export const pink = {
  backgroundColor: PVLightPink,
  textColor,
};

export const EventStatusColors = {
  pending: PVLightGray,
  active_events: PVHoverNavy,
  confirmed: PVGreen,
  balance_due: PVLightPink,
  completed_ytd: PVNavy,
  lead: PVYellow,
  qualified: PVOrange,
  proposal_sent: PVPurple,
  lost: PVLightGray,
  canceled: PVLightGray,
  completed: PVNavy,
};

/**
 * Determines if a color is light or dark.
 * @param hexColor - The hex color to check.
 * @returns True if the color is light, false otherwise.
 */
export const isLightColor = (hexColor: string) => {
  // Convert hex to RGB
  const r = parseInt(hexColor.substring(1, 3), 16);
  const g = parseInt(hexColor.substring(3, 5), 16);
  const b = parseInt(hexColor.substring(5, 7), 16);

  // Calculate perceived brightness (luminance)
  // This formula accounts for human perception where green contributes most to brightness.
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // You can adjust this threshold based on your desired definition of "light" vs "dark"
  // A common threshold is 128 (out of 255)
  return brightness > 128;
};

export const getContrastColor = (hexColor: string) =>
  isLightColor(hexColor) ? 'black' : 'white';
